import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, IconButton, Tooltip } from '@mui/material';
// universe
import Icon from '../../universe/Icon';
import { accentOf, accentTint } from '../../../theme/universe/brand';
import { iconButtonSx } from '../../../theme/universe/buttonSx';

// ----------------------------------------------------------------------
// THE WAY INTO THE SETTINGS, in the header: an icon button of the system
// (§17 "icon": round, ghost, the accent under the pointer, a 44px hit area
// on touch) carrying the registry's gear. While the panel is open the gear is
// lit, so the button reads as the panel's own. A dot says a setting differs
// from the defaults, where a caller passes `notDefault`.

ToggleButton.propTypes = {
  notDefault: PropTypes.bool,
  onToggle: PropTypes.func,
  open: PropTypes.bool
};

export default function ToggleButton({ notDefault, open, onToggle }) {
  const theme = useTheme();
  return (
    <Tooltip arrow title="Settings">
      <IconButton
        onClick={onToggle}
        aria-label="Settings"
        aria-expanded={Boolean(open)}
        sx={{
          ...iconButtonSx(theme, 40),
          position: 'relative',
          ...(open && {
            color: accentOf(theme),
            bgcolor: accentTint(theme, 'selected')
          })
        }}
      >
        <Icon name="Setting2" size="md" variant={open ? 'Bold' : 'Linear'} />
        {notDefault && !open && (
          <Box
            component="span"
            aria-hidden
            sx={{
              position: 'absolute',
              top: 7,
              right: 7,
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: accentOf(theme),
              boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
}
